<template>
    <input
        v-model="displayValue"
        type="text"
        :disabled="disabled"
        @blur="isInputActive = false"
        @focus="isInputActive = true"
    />
</template>

<script>
export default {
    props: {
        value: {
            required: true,
            validator: value => typeof value === 'number' || value === null
        },

        centsDivider: {
            type: Number,
            default: 100
        },

        defaultValue: {
            type: Number,
            default: null
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isInputActive: false
        };
    },

    computed: {
        displayValue: {
            get() {
                if (!this.value && this.value !== 0) {
                    return '';
                }

                let numberValue = parseFloat(this.value);

                if (this.centsDivider) {
                    numberValue /= this.centsDivider;
                }

                if (this.isInputActive) {
                    return numberValue.toString();
                }

                return (
                    '₪ ' +
                    numberValue
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
                );
            },
            set(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''));

                if (isNaN(newValue)) {
                    newValue = this.defaultValue;
                }

                if (newValue && this.centsDivider) {
                    newValue *= this.centsDivider;
                }

                this.$emit('input', newValue);
            }
        }
    }
};
</script>
